import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/residence/residence-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/residence/residence-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/app/src/components/ui/checkbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
